import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Translation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { shipmentStatusBefore } from '../mappings';

function getGenerateBolOverlay() {
  return (
    <Popover id="generate-bol-popover">
      <Translation>
          {(t, { i18n }) => <p>{t('GENERATE_BOL_FAILURE_FOR_SHIPMENT_ACCEPTED')}</p>}
        </Translation>
    </Popover>
  );
}

class GenerateBol extends Component {

  renderGenerateBolButton(canGenerateBol) {
    const { t } = this.props;
    return (
      <span className="cancel-btn-wrapper">
        <Button bsStyle="success" onClick={this.props.onGenerateBol} disabled={!canGenerateBol} >
          {t('GENERATE_BOL')}
        </Button>
      </span>
    );
  }

  render() {
    const canGenerateBol = this.props.isShipper && shipmentStatusBefore(this.props.current_status, 'accepted');
    return (
      <section>
        {!canGenerateBol && (
          <OverlayTrigger placement="right" trigger={['hover', 'focus']} overlay={getGenerateBolOverlay()}>
            {this.renderGenerateBolButton(canGenerateBol)}
          </OverlayTrigger>
        )}
        {canGenerateBol && this.renderGenerateBolButton(canGenerateBol)}
      </section>
    );
  }
}

GenerateBol.propTypes = {
  current_status: PropTypes.string.isRequired,
  isShipper: PropTypes.bool.isRequired,
  onGenerateBol: PropTypes.func.isRequired,
};

export default withTranslation()(GenerateBol);
